import { useMemo } from 'react';

import type { DropdownMenu2Props } from './types';

/**
 * 드롭다운메뉴의 앵커 요소를 계산합니다.
 */
export function useComputedAnchor(
  anchorEl: DropdownMenu2Props['anchorEl'],
  anchorPosition: DropdownMenu2Props['anchorPosition'],
  anchorReference: DropdownMenu2Props['anchorReference'],
) {
  return useMemo(() => {
    if (anchorReference === 'anchorPosition' && anchorPosition) {
      return {
        getBoundingClientRect: () => ({
          top: anchorPosition.top,
          left: anchorPosition.left,
          width: 0,
          height: 0,
          bottom: anchorPosition.top,
          right: anchorPosition.left,
          x: anchorPosition.left,
          y: anchorPosition.top,
          toJSON: () => '',
        }),
      };
    }
    return anchorEl;
  }, [anchorReference, anchorPosition, anchorEl]);
}
